import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ad9d4aae&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/styles/button.less?vue&type=style&index=0&id=ad9d4aae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9d4aae",
  null
  
)

export default component.exports